import { SelectOutlined } from "@nova/component-select"
import { FunctionComponent, useMemo } from "react"
import { useAircraft } from "../aircraft/AircraftQueries"

interface AircraftPickerProps {
    value: string
    onChange: (aircraftId: string) => void
    placeholder?: string
    disabled?: boolean
    label?: string
}

export const AircraftPicker: FunctionComponent<AircraftPickerProps> = ({
    value,
    onChange,
    placeholder = "Select drone",
    disabled,
    label,
}) => {
    const { aircraft } = useAircraft()

    const options = useMemo(
        () =>
            aircraft.map((a) => ({
                label: a.nickname ? `${a.nickname} (${a.model})` : (a.model ?? a.id),
                value: a.id,
            })),
        [aircraft]
    )

    return (
        <div className="flex flex-col gap-2 w-full">
            {label && <label className="text-gray-100">{label}</label>}
            <SelectOutlined<string>
                options={options}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                searchable
                className="w-full"
            />
        </div>
    )
}
